import styled from 'styled-components';

const Container = styled.div`
  background-image: ${({ backgroundImage, gradientDirection }) => {
    return `${
      gradientDirection
        ? `linear-gradient(${gradientDirection.toLowerCase()}, rgba(0,0,0,1) 0%, rgba(0,212,255,0) 78%),`
        : ''
    }
    ${backgroundImage ? `url(${backgroundImage})` : ''}`;
  }};
  background: ${({ bgColor, customBackgroundDesktop, customBackgroundMobile }) =>
    customBackgroundDesktop || customBackgroundMobile || bgColor};
  background-size: cover;
  background-repeat: no-repeat;
  ${({ backgroundImage }) =>
    backgroundImage &&
    `@media (max-width: 576px) {
    
      background-image: linear-gradient(
      rgba(20,20,20, .6), 
      rgba(20,20,20, .6)),
      url(${backgroundImage})
    }`};
  height: ${({ heightDesktop, heightMobile }) => heightDesktop || heightMobile};
  margin: ${({ childRow, marginDesktop, marginMobile }) => marginDesktop || marginMobile};
  padding: ${({ paddingDesktop, paddingMobile }) => paddingDesktop || paddingMobile};
  display: ${({ displayDesktop }) => displayDesktop};
  width: 100%;

  @media (max-width: 576px) {
    background: ${({ bgColor, customBackgroundMobile }) => customBackgroundMobile || bgColor};
    height: ${({ heightMobile }) => heightMobile};
    margin: ${({ marginMobile }) => marginMobile};
    padding: ${({ paddingMobile }) => paddingMobile};
    display: ${({ displayMobile }) => displayMobile};
  }
`;

const InnerContainer = styled.div`
  width: 100%;
  margin: 0px auto;
  padding: ${({ fullWidth }) => (fullWidth ? 0 : '75px 28px')};
  position: relative;

  @media (max-width: 768px) {
    padding: ${({ childRow }) => (childRow ? '48px 0' : '48px 18px')};
  }

  @media (max-width: 576px) {
    padding: ${({ childRow, paddingMobile }) =>
      paddingMobile ? `${paddingMobile} !important` : '30px 0'};
  }
`;

export { Container, InnerContainer };
